/* ErrorBoundary — wraps page routes so a runtime error in one page doesn't
 * blank out the entire app. Shows a friendly message + "Reload" / "Go home"
 * buttons. The actual error is logged to the console so we can debug.
 */
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[SenrizeFlow] page error:", error, info);
  }
  reset = () => { this.setState({ hasError: false, error: null }); };
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full text-center space-y-4 border border-border rounded-lg p-8 bg-card">
          <div className="text-4xl">⚠️</div>
          <h1 className="text-xl font-semibold heading">Something went wrong on this page</h1>
          <p className="text-sm text-muted-foreground">
            The rest of the app is fine. Try reloading the page, or jump to a different section from the sidebar.
          </p>
          {this.state.error?.message && (
            <details className="text-left text-[11px] text-muted-foreground bg-muted/40 rounded p-2 mt-2">
              <summary className="cursor-pointer">Technical details</summary>
              <pre className="whitespace-pre-wrap overflow-auto max-h-32 mt-2">{String(this.state.error.message)}</pre>
            </details>
          )}
          <div className="flex items-center justify-center gap-2 pt-2">
            <button
              onClick={() => { this.reset(); window.location.reload(); }}
              className="px-4 py-2 rounded-md bg-teal text-white text-sm hover:bg-teal/90"
              data-testid="error-reload">
              Reload page
            </button>
            <button
              onClick={() => { this.reset(); window.location.href = "/"; }}
              className="px-4 py-2 rounded-md border border-border text-sm hover:bg-muted"
              data-testid="error-home">
              Go home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
